import { cn } from "./cn.js";
import type { PrimaryNav as PrimaryNavId } from "./nav.js";

const TABS: readonly { id: PrimaryNavId; label: string }[] = [
	{ id: "agents", label: "Agents" },
	{ id: "sites", label: "Websites" },
	{ id: "connectors", label: "Connectors" },
	{ id: "channels", label: "Channels" },
];

type Props = {
	value: PrimaryNavId;
	setupDone: boolean;
	onChange: (next: PrimaryNavId) => void;
	className?: string;
};

/** Main-chrome surface switcher — sidebar stays the agents desk. */
export function PrimaryNav({ value, setupDone, onChange, className }: Props) {
	return (
		<nav className={cn("nav-segments", className)} aria-label="Primary">
			{TABS.map((tab) => {
				const locked = !setupDone && tab.id !== "agents";
				return (
					<button
						key={tab.id}
						type="button"
						className="nav-segment"
						aria-current={value === tab.id ? "page" : undefined}
						disabled={locked}
						onClick={() => onChange(tab.id)}
					>
						{tab.label}
					</button>
				);
			})}
		</nav>
	);
}
